module.exports = __webpack_public_path__ + "static/media/affection-baby-baby-girl-beautiful-377058.80961a00.jpg";